import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Columna 1 - Marca */}
          <div className="lg:pr-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/b83edec3-c6f5-4be0-8fe6-58c78499e6e3.png" 
              alt="ECOSERVEIS Logo" 
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-gray-300 text-[15px] leading-relaxed mb-6">
              Especialistas en <a 
                href="https://www.vaciarlocales.net/vaciado-de-locales-y-almacenes-comerciales-en-barcelona/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors duration-300 underline"
              >
                vaciado de locales
              </a>, naves industriales y oficinas en Barcelona. Servicio rápido, legal y con gestión responsable de residuos.
            </p>
            <div className="flex items-center space-x-3">
              <a
                href="https://maps.app.goo.gl/kGNXARTnHrknyJRDA"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white hover:text-[#1A1A1A] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-map-pin-line text-lg"></i>
              </a>
              <a
                href="https://wa.me/34644613451"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white hover:text-[#1A1A1A] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Columna 2 - Contacto */}
          <div>
            <h3 className="text-white text-xs font-bold uppercase tracking-wider mb-6">
              Contacto
            </h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-3">
                  <i className="ri-map-pin-2-fill text-[#FF6B35]"></i>
                </div>
                <a
                  href="https://maps.app.goo.gl/kGNXARTnHrknyJRDA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 text-[15px] hover:text-white transition-colors cursor-pointer"
                >
                  Av. Nord 11 B-2, 08905<br />
                  L'Hospitalet de Llobregat, Barcelona
                </a>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-phone-fill text-[#FF6B35]"></i>
                </div>
                <a
                  href="tel:+34644613451"
                  className="text-gray-300 text-[15px] hover:text-white transition-colors cursor-pointer"
                >
                  +34 644 613 451
                </a>
              </div>
              <div className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 mr-3">
                  <i className="ri-time-line text-[#FF6B35]"></i>
                </div>
                <p className="text-gray-300 text-[15px]">
                  Horario: Consultar disponibilidad
                </p>
              </div>
            </div>
          </div>

          {/* Columna 3 - Enlaces Rápidos */}
          <div>
            <h3 className="text-white text-xs font-bold uppercase tracking-wider mb-6">
              Enlaces Rápidos
            </h3>
            <nav className="space-y-3">
              <Link
                to="/"
                className="block text-gray-300 text-[15px] hover:text-white transition-colors"
              >
                Inicio
              </Link>
              <Link
                to="/empresa"
                className="block text-gray-300 text-[15px] hover:text-white transition-colors"
              >
                Empresa
              </Link>
              <Link
                to="/servicios"
                className="block text-gray-300 text-[15px] hover:text-white transition-colors"
              >
                Servicios
              </Link>
              <Link
                to="/faq"
                className="block text-gray-300 text-[15px] hover:text-white transition-colors"
              >
                Preguntas Frecuentes
              </Link>
              <Link
                to="/contacto"
                className="block text-gray-300 text-[15px] hover:text-white transition-colors"
              >
                Contacto
              </Link>
              <a
                href="mailto:info@ecoserveis.com?subject=Trabaja con nosotros"
                className="block text-gray-300 text-[15px] hover:text-white transition-colors"
              >
                Trabaja con Nosotros
              </a>
            </nav>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-[13px]">
              © {new Date().getFullYear()} ECOSERVEIS. Todos los derechos reservados.
            </p>
          </div>

          {/* Legal Links */}
          <div className="mt-6 flex flex-wrap justify-center items-center gap-4">
            <Link
              to="/politica-cookies"
              className="text-gray-400 text-[13px] hover:text-white transition-colors"
            >
              Política de Cookies
            </Link>
            <span className="text-gray-600">|</span>
            <Link
              to="/aviso-legal"
              className="text-gray-400 text-[13px] hover:text-white transition-colors"
            >
              Aviso Legal
            </Link>
            <span className="text-gray-600">|</span>
            <Link
              to="/politica-privacidad"
              className="text-gray-400 text-[13px] hover:text-white transition-colors"
            >
              Política de Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;